<template>
  <div class="seleccion-container">
    <!-- Logo -->
    <div class="logos">
      <img src="@/assets/logonav.png" alt="HP y RM" />
    </div>

    <!-- Sección términos -->
    <div class="form-section">
      <h2>
        Al continuar aceptas los términos y condiciones de la actividad.
      </h2>

      <p class="info-text">
        Para mayor información visita:
        <a
          href="http://terminosycondiciones.hpinfo.online/"
          target="_blank"
          rel="noopener noreferrer"
        >
          http://terminosycondiciones.hpinfo.online/
        </a>
      </p>
    </div>

    <!-- Botón continuar (mismo diseño, nuevo texto) -->
    <div class="footer">
      <div class="line-button" @click="avanzar">
        <hr />
        <span>Acepto los términos y condiciones</span>
        <hr />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    avanzar() {
      this.$router.push('/tomafoto')
    },
  },
}
</script>

<style scoped lang="scss">
.seleccion-container {
  background: linear-gradient(to right, #48465c 0%, #211f2e 50%, #151d2b 100%);
  color: white;
  min-height: 100vh;
  width: 100%;
  padding: 2rem;
  font-family: 'FormaDJRDisplay', sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.logos {
  position: absolute;
  top: 2vh;
  left: 2vw;

  img {
    width: 40vw;
  }
}

.form-section {
  text-align: left;
  max-width: 80vw;
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  align-content: center;

  h2 {
    font-size: 4vw;
    margin-bottom: 3vw;
    line-height: 1.2;
  }

  .info-text {
    font-size: 2.5vw;
    line-height: 1.4;
    letter-spacing: 0.05vw;

    a {
      color: white;
      text-decoration: underline;
    }
  }
}

.footer {
  margin-top: auto;
  width: 100%;
  text-align: center;
  padding-top: 2rem;
  z-index: 3;
  position: relative;

  .line-button {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    gap: 2vw;
    flex-direction: column;

    span {
      padding: 0.5vw 2vw;
      font-size: 2.5vw;
      border-top: 1px solid #fff;
      border-bottom: 1px solid #fff;

      &:hover {
        background: white;
        color: #0095d9;
        transition: all 0.3s;
      }
    }
  }
}
</style>
